/**
 * Card Component - Container for grouped content
 */

import React from 'react';
import { View, StyleSheet, ViewStyle } from 'react-native';
import { colors } from '../theme/tokens';

interface CardProps {
  children: React.ReactNode;
  style?: ViewStyle;
  testID?: string;
}

/**
 * Card Component
 */
export const Card: React.FC<CardProps> = ({ children, style, testID }) => {
  const cardStyle: ViewStyle = {
    backgroundColor: colors.white,
    borderRadius: 12,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginVertical: 8,
    // @ts-ignore - boxShadow is valid for web
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
    elevation: 2, // For Android
  };

  return (
    <View style={[cardStyle, style]} testID={testID}>
      {children}
    </View>
  );
};

